import RequestHandler from "./RequestHandler";

function ScansAPI() {
    const baseScansAPI = "scans";

    async function getScans(groupBy, filters = {}) {
        try {
            const result = await RequestHandler.post(
                `${baseScansAPI}/group/${groupBy}`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getScansList(filters = {}) {
        try {
            const result = await RequestHandler.post(
                `${baseScansAPI}/group`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getScansWithDetails(itemsPerPage, filters, offset = 0) {
        try {
            const skip = offset * itemsPerPage;
            const result = await RequestHandler.post(
                `${baseScansAPI}/details?skip=${skip}&take=${itemsPerPage}`,
                filters
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function exportScans(filters, export_type) {
        try {
            const result = await RequestHandler.post(
                `${baseScansAPI}/export?export_type=${export_type}&device_type=portal`,
                filters
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getScanMeasurementsWithDetails(
        itemsPerPage,
        criteria,
        offset = 0,
        filters
    ) {
        try {
            const skip = offset * itemsPerPage;
            const result = await RequestHandler.post(
                `${baseScansAPI}/measurement-details?skip=${skip}&take=${itemsPerPage}`,
                { criteria, filters }
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function createScan(scanData) {
        try {
            const result = await RequestHandler.post(
                `${baseScansAPI}/`,
                scanData
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function markScansAsMeasurement(ids, includePredictions) {
        try {
            const result = await RequestHandler.post(
                `${baseScansAPI}/mark-measurement/${includePredictions}`,
                ids
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteScanMeasurements(scanKeys) {
        try {
            const result = await RequestHandler.remove(
                `${baseScansAPI}/measurements`,
                scanKeys
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteScans(scanIds) {
        try {
            const result = await RequestHandler.remove(
                `${baseScansAPI}/`,
                scanIds
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteScanReadings(scanId, scanKeys) {
        try {
            const result = await RequestHandler.remove(
                `${baseScansAPI}/${scanId}/readings`,
                scanKeys
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getScanDetailsById(scanId) {
        try {
            const result = await RequestHandler.get(
                `${baseScansAPI}/details/${scanId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function editScan({ scanId, ...payload }) {
        try {
            const result = await RequestHandler.put(baseScansAPI, {
                id: scanId,
                ...payload,
            });
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function syncScans(scanIds) {
        try {
            const result = await RequestHandler.put(
                `${baseScansAPI}/retry-integration`,
                scanIds
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getScans,
        getScansWithDetails,
        exportScans,
        deleteScanReadings,
        createScan,
        deleteScans,
        markScansAsMeasurement,
        getScansList,
        deleteScanMeasurements,
        getScanMeasurementsWithDetails,
        getScanDetailsById,
        editScan,
        syncScans,
    };
}

export default ScansAPI();
